import { AlpineComponentTryba } from '../../scripts/alpine/include/global';
import { activateAbTestByEvent } from '../../scripts/ab/registry';

// AB Test 86c5mdwbh - Quotation form instead of appointment
export default (): AlpineComponentTryba => ({
    init() {
        window.addEventListener('expressAppointementToQuotation', () => {
            activateAbTestByEvent('expressAppointementToQuotation');
            this.$store.ab.appointmentFormChangedToQuotation = true;
            this.run();
        });
    },
    run() {
        if (this.$store.ab.appointmentFormChangedToQuotation && document.body.dataset.type === 'realisation') {
            const formAppointment = document.querySelector('.express_appointment_form') as HTMLElement;
            const formQuotation = document.querySelector('.js-ab-test-quotation-form-instead-appointment') as HTMLElement;
            if (formAppointment) formAppointment.classList.add('hidden');
            if (formQuotation) formQuotation.classList.remove('hidden');
        }
    },
});
